import React from 'react'

export default () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M16.5439 16.5427C16.9344 16.1522 17.5676 16.1522 17.9581 16.5427L21.7082 20.2929C22.0988 20.6834 22.0988 21.3166 21.7082 21.7071C21.3177 22.0976 20.6845 22.0976 20.294 21.7071L16.5439 17.957C16.1533 17.5664 16.1533 16.9333 16.5439 16.5427Z" fill="#194074"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M10.0003 4C6.68642 4 4 6.68642 4 10.0003C4 13.3141 6.68642 16.0006 10.0003 16.0006C13.3141 16.0006 16.0006 13.3141 16.0006 10.0003C16.0006 6.68642 13.3141 4 10.0003 4ZM2 10.0003C2 5.58185 5.58185 2 10.0003 2C14.4187 2 18.0006 5.58185 18.0006 10.0003C18.0006 14.4187 14.4187 18.0006 10.0003 18.0006C5.58185 18.0006 2 14.4187 2 10.0003Z" fill="#194074"/>
  </svg>

)
